module.exports = __webpack_public_path__ + "img/1-participated.f5a91a44.png";